import { Reveal } from "@/components/Reveal";
import { ShieldCheck } from "lucide-react";
import { ABOUT } from "@/data/site";

export default function About() {
  return (
    <section id="about" className="relative scroll-mt-24 py-20 sm:py-28" data-testid="about">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-border bg-card/50 p-8 grain sm:p-14">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-sage/10 blur-3xl" />
          <Reveal className="relative">
            <p className="eyebrow">About Warranty_Vault pro</p>
            <h2 className="mt-3 max-w-3xl font-display text-2xl font-bold leading-snug tracking-tight sm:text-3xl">
              {ABOUT.lead}
            </h2>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground">
              {ABOUT.mission}
            </p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-4 py-2 text-sm font-medium text-gold">
              <ShieldCheck className="h-4 w-4" /> Protecting purchases for households & businesses
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
